import AccountIcon from './account-icon.png';
import ForbiddenIcon from './forbidden-icon.png';
import KeyIcon from './key-icon.png';
import LockIcon from './lock-icon.png';
import MailIcon from './mail-box-icon.png';
import SpaceIcon from './space-man-icon.png';
import VirginIcon from './virgin-icon.png';

const icons = {
    AccountIcon,
    ForbiddenIcon,
    KeyIcon,
    LockIcon,
    MailIcon,
    SpaceIcon,
    VirginIcon,
} as const;

export default icons;
